// Testing widths: 360, 540, 810(iPad), 1270, full. samsung s6 is 360x615

import './App.css';
import { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

import SetupName from './components/SetupName';
import SetupSubscription from './components/SetupSubscription';
import Projects from './components/Projects';
import Project from './components/Project';
import Schedule from './components/Schedule';
import FreeSchedule from './components/FreeSchedule';
import DailyReports from './components/DailyReports';
import LoadingOverlay from './components/LoadingOverlay';
import ConnectingOverlay from './components/ConnectingOverlay';
import AlertOverlay from './components/AlertOverlay';
import NewProjectDialogue from './components/NewProjectDialogue';
import EditProjectDialogue from './components/EditProjectDialogue';
import DeleteProjectDialogue from './components/DeleteProjectDialogue';
import DeleteScheduleDialogue from './components/DeleteScheduleDialogue';
import PublishScheduleDialogue from './components/PublishScheduleDialogue';
import UnpublishScheduleDialogue from './components/UnpublishScheduleDialogue';
import ShareLinkDialogue from './components/ShareLinkDialogue';
import NewScheduleDialogue from './components/NewScheduleDialogue';
import MyProfileDialogue from './components/MyProfileDialogue';
import EditContractorsDialogue from './components/EditContractorsDialogue';
import NewDailyReportDialogue from './components/NewDailyReportDialogue';
import EditDailyReportDialogue from './components/EditDailyReportDialogue';
import DeleteDailyReportDialogue from './components/DeleteDailyReportDialogue';
import PrivacyPolicyDialogue from './components/PrivacyPolicyDialogue';
import TermsOfUseDialogue from './components/TermsOfUseDialogue';
import FeedbackDialogue from './components/FeedbackDialogue';
import AdminDialogue from './components/AdminDialogue';
import ScheduleMessagesDialogue from './components/ScheduleMessagesDialogue';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import HelpFloater from './components/HelpFloater';
import LandingPage from './components/LandingPage';
import UnreadMessagesDialogue from './components/UnreadMessagesDialogue';
import WelcomeDialogue from './components/WelcomeDialogue';
import UpgradeToStandardSubscriptionDialogue from './components/UpgradeToStandardSubscriptionDialogue';
import SubscriptionChooserPopup from './components/SubscriptionChooserPopup';
import EditSubscriptionManagersDialogue from './components/EditSubscriptionManagersDialogue';
import UserRoleInfoDialogue from './components/UserRoleInfoDialogue';
import InviteSignupPage from './components/InviteSignupPage';
import PromoSignupPage from './components/PromoSignupPage';
import InviteSubscriptionContactSignupPage from './components/InviteSubscriptionContactSignupPage';
import SubscriptionContactUnsubscribePage from './components/SubscriptionContactUnsubscribePage';
import SharedSchedulePage from './components/SharedSchedulePage';
import AddProjectMemberDialogue from './components/AddProjectMemberDialogue';
import JustJoinedSubscriptionDialogueId from './components/JustJoinedSubscriptionDialogueId';
import DeleteScheduleContactDialogue from './components/DeleteScheduleContactDialogue';
import ProjectContactsDialogue from './components/ProjectContactsDialogue';
import EditScheduleDialogue from './components/EditScheduleDialogue';
import DeletePromoCodeDialogue from './components/DeletePromoCodeDialogue';
import DialogueSetPromoCodeNote from './components/DialogueSetPromoCodeNote';
import DialogueSetPromoCodeExpiration from './components/DialogueSetPromoCodeExpiration';
import RequestScheduleEmailUpdatesDialogue from './components/RequestScheduleEmailUpdatesDialogue';
import ConfirmWorkDatesDialogue from './components/ConfirmWorkDatesDialogue';
import ReviewSharedScheduleViewsDialogue from './components/ReviewSharedScheduleViewsDialogue';
import ReviewSharedScheduleConfirmationsDialogue from './components/ReviewSharedScheduleConfirmationsDialogue';
import ScheduleUnlockedConfirmationDialogue from './components/ScheduleUnlockedConfirmationDialogue';
import SchedulePublishedConfirmationDialogue from './components/SchedulePublishedConfirmationDialogue';

import { WEBSOCKET_AUTHORIZED, SET_IS_TOUCH_DEVICE, SET_APP_FOCUSED, Email, LoginCode, isSubscriptionStarted, DateStringMMDDYYYY, } from './actions/types';
import { siteboardAction } from './actions/defaultActions';
import { keyIsInObject, keyCountInObject, getJsonFromUrl } from './Util';

// test cases
const testLandingPage = false;
const testSetupNamePage = false;
const testSetupSubscriptionPage = false;
const testInviteSignupPage = false;
const testPromoSignupPage = false;
const testContactInviteSignupPage = false;
const testContactUnsubscribePage = false;

function App({_users, _userId, _projects, _schedules, _subscriptions, _isLoggedIn, _path, _loadingMessage, _alertMessage, _websocketState, _editProjectDialogueId, _editProjectMembersDialogueId, _deleteProjectDialogueId, _deleteScheduleDialogueId, _publishScheduleDialogueId, _unpublishScheduleDialogueId, _profileDialogueShowing, _newScheduleDialogueProjectId, _newScheduleDialogueScheduleId, _editContractorsDialogueId, _newDailyReportDialogueId, _dailyReports, _dailyReportSummaries, _deleteDailyReportDialogueId, _editDailyReportDialogueId, _isPrivacyPolicyDialogueOpen, _isTermsOfUseDialogueOpen, _isFeedbackDialogueOpen, _isAdminDialogueOpen, _scheduleMessagesDialogueProjectId, _userPreferences, _isUnreadMessagesDialogueOpen, _isTrialWelcomeDialogueOpen, siteboardAction, _isUpgradeToStandardDialogueOpen, _isSubscriptionChooserDialogueOpen, _isEditSubscriptionManagersDialogueOpen, _isUserRoleInfoDialogueShowing, _isUsingInviteLink, _isUsingInviteSubscriptionContactLink, _isUsingUnsubscribeSubscriptionContactLink, _subscriptionInvites, _justJoinedSubscriptionDialogueId, _deleteContactDialogueOpen, _projectContactsDialogueId, _localOnlyMode, _shareScheduleLinkDialogueOpen, _shareScheduleLinkDialogueScheduleId, _isUsingShareScheduleLink, _editScheduleDialogueOpen, _editScheduleDialogueScheduleId, _requestScheduleEmailUpdatesDialogueOpen, _confirmWorkDatesDialogueOpen, _reviewSharedScheduleViewsDialogueOpen, _reviewSharedScheduleConfirmationsDialogueOpen, _promoCodes, _deletePromoCodeDialogueOpen, _deletePromoCodeDialoguePromoCodeId, _setNotePromoCodeDialogueOpen, _setNotePromoCodeDialoguePromoCodeId, _setExpirationPromoCodeDialogueOpen, _setExpirationPromoCodeDialoguePromoCodeId, _isUsingPromoSignupLink, _scheduleUnlockedConfirmationShowing, _schedulePublishedConfirmationShowing, _newProjectDialogueIsShowing, }) {

  const getUserFirstName = useCallback(() => {
    try { return _users[_userId].firstName; } catch(error) { return ''; }
  }, [_users, _userId]);

  const getUserLastName = useCallback(() => {
    try { return _users[_userId].lastName; } catch(error) { return ''; }
  }, [_users, _userId]);

  const userBelongsToNoActiveSubscriptions = useCallback(() => {
    try {
      const user = _users[_userId];
      if(keyCountInObject(user.subscriptions) > 0) throw new Error('User is a member of another persons subscription');
      const userSubscription = _subscriptions[user.ownedSubscriptionId];
      if(isSubscriptionStarted(userSubscription)) throw new Error('User has started their own subscription');
      return true;
    } catch(error) {}
    return false;
  }, [_users, _userId, _subscriptions]);
  
  const getEffectiveScheduleId = (project, scheduleId) => {
    if(!project) return null;
    if((!scheduleId || !(scheduleId in project.schedules)) && keyCountInObject(project.schedules) > 0) {
      // Use most recent project schedule if scheduleId is not valid
      const sortedSchedules = [];
      for(const key in project.schedules) {
        sortedSchedules.push({ id: key, beginDate: project.schedules[key] });
      }
      sortedSchedules.sort((one, two) => {
        try {
          const oneDate = DateStringMMDDYYYY.toDateObject(one.beginDate);
          const twoDate = DateStringMMDDYYYY.toDateObject(two.beginDate);
          return twoDate.getTime() - oneDate.getTime();
        } catch(error) {
          return 0;
        }
      });
      return sortedSchedules[0].id;
    }
    if(scheduleId in project.schedules) return scheduleId;
    return null;
  };

  // Apply dark mode style to html element
  useEffect(() => {
    if (_userPreferences.darkMode === true) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [_userPreferences.darkMode]);

  // Listen for when the window tab is focused and unfocused
  useEffect(() => {
    const setIsTabFocused = (isFocused) => {
      siteboardAction(SET_APP_FOCUSED, { isFocused: isFocused });
      // TODO: toggle between "X New messages" and SiteBoard to alert the user the tab has new messages (if the user is not focused on this tab)
      //document.title = process.env.REACT_APP_WEBSITE_NAME + (isFocused ? ' focused ' : ' not focused');
    };
    const handleVisibilityChange = () => { setIsTabFocused(document.hasFocus()); };
    const handleFocus = () => setIsTabFocused(true);
    const handleBlur = () => setIsTabFocused(false);

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [siteboardAction]);

  const onboardingContent = (() => {
    if(testLandingPage) return (<LandingPage />);
    if(testSetupNamePage) return (<SetupName />);
    if(testSetupSubscriptionPage) return (<SetupSubscription />);
    if(testInviteSignupPage) return (<InviteSignupPage />);
    if(testPromoSignupPage) return (<PromoSignupPage />);
    if(testContactInviteSignupPage) return (<InviteSubscriptionContactSignupPage />);
    if(testContactUnsubscribePage) return (<SubscriptionContactUnsubscribePage />);

    if(_isUsingInviteLink) return (<InviteSignupPage />);
    if(_isUsingPromoSignupLink) return (<PromoSignupPage />);
    if(_isUsingInviteSubscriptionContactLink) return (<InviteSubscriptionContactSignupPage />);
    if(_isUsingUnsubscribeSubscriptionContactLink) return (<SubscriptionContactUnsubscribePage />);
    if(_isUsingShareScheduleLink) return (<SharedSchedulePage />);
    if(_localOnlyMode) return (<FreeSchedule />);
    if(_isLoggedIn === false) return (<LandingPage />);
    if(_websocketState !== WEBSOCKET_AUTHORIZED) return (<ConnectingOverlay />);
    if(getUserFirstName().length === 0 || getUserLastName().length === 0) return (<SetupName />);
    if(userBelongsToNoActiveSubscriptions() && keyCountInObject(_subscriptionInvites) === 0) return (<SetupSubscription />);

    return 'onboardingCompleted';
  })();

  const loggedInContent = (() => {
    if(onboardingContent !== 'onboardingCompleted') return <></>;

    let content = null;
    let selectedProjectId = null;
    let selectedScheduleId = null;

    if(_path.match(/^projectId#[a-fA-F0-9-]+$/)) {
      const match = _path.match(/^projectId#([a-fA-F0-9-]+)$/);
      if(match[1] in _projects) {
        selectedProjectId = match[1];
        content = (<Project projectId={selectedProjectId} />);
      }
    } 
    if(_path.match(/^projectId#([a-fA-F0-9-]+)#schedule$/)) {
      const match = _path.match(/^projectId#([a-fA-F0-9-]+)#schedule$/);
      if(match[1] in _projects) {
        selectedProjectId = match[1];
        selectedScheduleId = getEffectiveScheduleId(_projects[selectedProjectId], null);
        content = (<Schedule projectId={selectedProjectId} scheduleId={selectedScheduleId} />);
      }
    } 
    if(_path.match(/^projectId#([a-fA-F0-9-]+)#scheduleId#([a-fA-F0-9-]+)$/)) {
      const match = _path.match(/^projectId#([a-fA-F0-9-]+)#scheduleId#([a-fA-F0-9-]+)$/);
      if(match[1] in _projects) {
        selectedProjectId = match[1];
        selectedScheduleId = getEffectiveScheduleId(_projects[selectedProjectId], match[2]);
        content = (<Schedule projectId={selectedProjectId} scheduleId={selectedScheduleId} />);
      }
    } 
    if(process.env.REACT_APP_DAILY_REPORTS_ENABLE === 'true' && _path.match(/^projectId#([a-fA-F0-9-]+)#dailyReports$/)) {
      const match = _path.match(/^projectId#([a-fA-F0-9-]+)#dailyReports$/);
      selectedProjectId = match[1];
      if(selectedProjectId in _projects) {
        content = (<DailyReports projectId={selectedProjectId} />);
      }
    }
    if(!content) {
      content = (<Projects />); // default path
    }

    return (
      <div className='print:block print:w-full print:h-auto flex flex-col xl:flex-row w-screen h-screen overflow-hidden'>
        {/* Sidebar (wide screen)  */}
        <div className={`hidden xl:block print:hidden`}><Sidebar selectedProjectId={selectedProjectId} selectedScheduleId={selectedScheduleId} /></div>
        {/* Topbar (narrow screen) */}
        <div className={`xl:hidden print:hidden`}><Topbar /></div>
        {/* Page Content */}
        {content}
      </div>
    );
  })();

  return (
    <div 
      className='text-[14px] md:text-[15px]'
      onTouchStart = {(event) => {
        siteboardAction(SET_IS_TOUCH_DEVICE, { isTouchDevice: true }); // detect touch devices with this event
      }}
    >
      {onboardingContent === 'onboardingCompleted' ?  (loggedInContent) : (onboardingContent) }
      {/* overlay layer */}
      <div className='absolute left-0 top-0 z-[10] print:hidden'>
        <HelpFloater onboardingCompleted={onboardingContent === 'onboardingCompleted'} />
        {_isPrivacyPolicyDialogueOpen === true && <PrivacyPolicyDialogue />}
        {_isTermsOfUseDialogueOpen === true && <TermsOfUseDialogue />}
        {onboardingContent === 'onboardingCompleted' &&
          <>
            {_isTrialWelcomeDialogueOpen === true && <WelcomeDialogue />}
            {_profileDialogueShowing === true && <MyProfileDialogue />}
            {_isUnreadMessagesDialogueOpen === true && <UnreadMessagesDialogue />}
            {keyIsInObject(_justJoinedSubscriptionDialogueId, _subscriptions) && <JustJoinedSubscriptionDialogueId />}
            {keyIsInObject(_newScheduleDialogueProjectId, _projects) && <NewScheduleDialogue />}
            {keyIsInObject(_publishScheduleDialogueId, _schedules) && <PublishScheduleDialogue />}
            {_newProjectDialogueIsShowing === true && <NewProjectDialogue />}
            {keyIsInObject(_editProjectDialogueId, _projects) && <EditProjectDialogue />}
            {keyIsInObject(_editProjectMembersDialogueId, _projects) && <AddProjectMemberDialogue />}
            {keyIsInObject(_projectContactsDialogueId, _projects) && <ProjectContactsDialogue />}
            {keyIsInObject(_deleteProjectDialogueId, _projects) && <DeleteProjectDialogue />}
            {keyIsInObject(_deleteScheduleDialogueId, _schedules) && <DeleteScheduleDialogue />}
            {keyIsInObject(_unpublishScheduleDialogueId, _schedules) && <UnpublishScheduleDialogue />}
            {_scheduleUnlockedConfirmationShowing === true && <ScheduleUnlockedConfirmationDialogue />}
            {_schedulePublishedConfirmationShowing === true && <SchedulePublishedConfirmationDialogue />}
            {_reviewSharedScheduleViewsDialogueOpen === true && <ReviewSharedScheduleViewsDialogue />}
            {_reviewSharedScheduleConfirmationsDialogueOpen === true && <ReviewSharedScheduleConfirmationsDialogue />}
            {_shareScheduleLinkDialogueOpen === true && keyIsInObject(_shareScheduleLinkDialogueScheduleId, _schedules) && <ShareLinkDialogue />}
            {keyIsInObject(_scheduleMessagesDialogueProjectId, _projects) && <ScheduleMessagesDialogue />}
            {(keyIsInObject(_newDailyReportDialogueId, _projects) || _newDailyReportDialogueId === 'new') && <NewDailyReportDialogue />}
            {(keyIsInObject(_editDailyReportDialogueId, _dailyReports) || keyIsInObject(_editDailyReportDialogueId, _dailyReportSummaries)) && <EditDailyReportDialogue />}
            {keyIsInObject(_deleteDailyReportDialogueId, _dailyReports) && <DeleteDailyReportDialogue />}
            {_deleteContactDialogueOpen === true && <DeleteScheduleContactDialogue />}
            {keyIsInObject(_editContractorsDialogueId, _projects) && <EditContractorsDialogue />}
            {_isFeedbackDialogueOpen === true && <FeedbackDialogue />}
            {_isAdminDialogueOpen === true && <AdminDialogue />}
            {_isUpgradeToStandardDialogueOpen === true && <UpgradeToStandardSubscriptionDialogue />}
            {_isSubscriptionChooserDialogueOpen === true && <SubscriptionChooserPopup />}
            {_isEditSubscriptionManagersDialogueOpen === true && <EditSubscriptionManagersDialogue />}
            {_isUserRoleInfoDialogueShowing === true && <UserRoleInfoDialogue />}
          </>
        }
        {_editScheduleDialogueOpen === true && keyIsInObject(_editScheduleDialogueScheduleId, _schedules) && <EditScheduleDialogue />}
        {_requestScheduleEmailUpdatesDialogueOpen === true && <RequestScheduleEmailUpdatesDialogue />}
        {(_deletePromoCodeDialogueOpen === true && keyIsInObject(_deletePromoCodeDialoguePromoCodeId, _promoCodes)) && <DeletePromoCodeDialogue />}
        {(_setNotePromoCodeDialogueOpen === true && keyIsInObject(_setNotePromoCodeDialoguePromoCodeId, _promoCodes)) && <DialogueSetPromoCodeNote />}
        {(_setExpirationPromoCodeDialogueOpen === true && keyIsInObject(_setExpirationPromoCodeDialoguePromoCodeId, _promoCodes)) && <DialogueSetPromoCodeExpiration />}
        {_confirmWorkDatesDialogueOpen === true && <ConfirmWorkDatesDialogue />}
        {(typeof _loadingMessage === 'string' && _loadingMessage.length > 0) && <LoadingOverlay message={_loadingMessage} />}
        {(typeof _alertMessage === 'string' && _alertMessage.length > 0) && <AlertOverlay message={_alertMessage} />}

        {process.env.REACT_APP_LIVE_MODE === 'false' &&
          <div className='fixed flex h-screen w-screen justify-end items-end p-1 pointer-events-none opacity-50'>
            <div className='font-bold text-xs text-red-500 px-1 rounded-[5px]'>Test Build</div>
          </div>
        }
      </div>
    </div>
  );
}

const mapStateToProps = state => { return {
  _users: state.serverSynced.users,
  _projects: state.serverSynced.projects,
  _schedules: state.serverSynced.schedules,
  _subscriptions: state.serverSynced.subscriptions,
  _dailyReports: state.serverSynced.dailyReports,
  _dailyReportSummaries: state.serverSynced.dailyReportSummaries,
  _isLoggedIn: state.localPersistent.isLoggedIn,
  _path: state.localPersistent.path,
  _loadingMessage: state.localEphemeral.loadingMessage,
  _alertMessage: state.localEphemeral.alertMessage,
  _websocketState: state.localEphemeral.websocketState,
  _userId: state.localPersistent.userId,
  _editProjectDialogueId: state.localEphemeral.editProjectDialogueId,
  _editProjectMembersDialogueId: state.localEphemeral.editProjectMembersDialogueId,
  _deleteProjectDialogueId: state.localEphemeral.deleteProjectDialogueId,
  _deleteScheduleDialogueId: state.localEphemeral.deleteScheduleDialogueId,
  _publishScheduleDialogueId: state.localEphemeral.publishScheduleDialogueId,
  _unpublishScheduleDialogueId: state.localEphemeral.unpublishScheduleDialogueId,
  _profileDialogueShowing: state.localEphemeral.profileDialogueShowing,
  _newScheduleDialogueProjectId: state.localEphemeral.newScheduleDialogueProjectId,
  _newScheduleDialogueScheduleId: state.localEphemeral.newScheduleDialogueScheduleId,
  _editContractorsDialogueId: state.localEphemeral.editContractorsDialogueId,
  _newDailyReportDialogueId: state.localEphemeral.newDailyReportDialogueId,
  _deleteDailyReportDialogueId: state.localEphemeral.deleteDailyReportDialogueId,
  _editDailyReportDialogueId: state.localEphemeral.editDailyReportDialogueId,
  _isPrivacyPolicyDialogueOpen: state.localEphemeral.isPrivacyPolicyDialogueOpen,
  _isTermsOfUseDialogueOpen: state.localEphemeral.isTermsOfUseDialogueOpen,
  _isFeedbackDialogueOpen: state.localEphemeral.isFeedbackDialogueOpen,
  _isAdminDialogueOpen: state.localEphemeral.isAdminDialogueOpen,
  _scheduleMessagesDialogueProjectId: state.localEphemeral.scheduleMessagesDialogueProjectId,
  _userPreferences: state.serverSynced.userPreferences,
  _isUnreadMessagesDialogueOpen: state.localEphemeral.isUnreadMessagesDialogueOpen,
  _isTrialWelcomeDialogueOpen: state.localEphemeral.isTrialWelcomeDialogueOpen,
  _isUpgradeToStandardDialogueOpen: state.localEphemeral.isUpgradeToStandardDialogueOpen,
  _isSubscriptionChooserDialogueOpen: state.localEphemeral.isSubscriptionChooserDialogueOpen,
  _isEditSubscriptionManagersDialogueOpen: state.localEphemeral.isEditSubscriptionManagersDialogueOpen,
  _isUserRoleInfoDialogueShowing: state.localEphemeral.isUserRoleInfoDialogueShowing,
  _isUsingInviteLink: state.localEphemeral.isUsingInviteLink,
  _isUsingInviteSubscriptionContactLink: state.localEphemeral.isUsingInviteSubscriptionContactLink,
  _isUsingUnsubscribeSubscriptionContactLink: state.localEphemeral.isUsingUnsubscribeSubscriptionContactLink,
  _subscriptionInvites: state.serverSynced.subscriptionInvites,
  _justJoinedSubscriptionDialogueId: state.localEphemeral.justJoinedSubscriptionDialogueId,
  _deleteContactDialogueOpen: state.localEphemeral.deleteContactDialogueOpen,
  _projectContactsDialogueId: state.localEphemeral.projectContactsDialogueId,
  _localOnlyMode: state.serverSynced.localOnlyMode,
  _shareScheduleLinkDialogueOpen: state.localEphemeral.shareScheduleLinkDialogueOpen,
  _shareScheduleLinkDialogueScheduleId: state.localEphemeral.shareScheduleLinkDialogueScheduleId,
  _isUsingShareScheduleLink: state.localEphemeral.isUsingShareScheduleLink,
  _editScheduleDialogueOpen: state.localEphemeral.editScheduleDialogueOpen,
  _editScheduleDialogueScheduleId: state.localEphemeral.editScheduleDialogueScheduleId,
  _requestScheduleEmailUpdatesDialogueOpen: state.localEphemeral.requestScheduleEmailUpdatesDialogueOpen,
  _confirmWorkDatesDialogueOpen: state.localEphemeral.confirmWorkDatesDialogueOpen,
  _reviewSharedScheduleViewsDialogueOpen: state.localEphemeral.reviewSharedScheduleViewsDialogueOpen,
  _reviewSharedScheduleConfirmationsDialogueOpen: state.localEphemeral.reviewSharedScheduleConfirmationsDialogueOpen,
  _promoCodes: state.serverSynced.promoCodes,
  _deletePromoCodeDialogueOpen: state.localEphemeral.deletePromoCodeDialogueOpen,
  _deletePromoCodeDialoguePromoCodeId: state.localEphemeral.deletePromoCodeDialoguePromoCodeId,
  _setNotePromoCodeDialogueOpen: state.localEphemeral.setNotePromoCodeDialogueOpen,
  _setNotePromoCodeDialoguePromoCodeId: state.localEphemeral.setNotePromoCodeDialoguePromoCodeId,
  _setExpirationPromoCodeDialogueOpen: state.localEphemeral.setExpirationPromoCodeDialogueOpen,
  _setExpirationPromoCodeDialoguePromoCodeId: state.localEphemeral.setExpirationPromoCodeDialoguePromoCodeId,
  _isUsingPromoSignupLink: state.localEphemeral.isUsingPromoSignupLink,
  _scheduleUnlockedConfirmationShowing: state.localEphemeral.scheduleUnlockedConfirmationShowing,
  _schedulePublishedConfirmationShowing: state.localEphemeral.schedulePublishedConfirmationShowing,
  _newProjectDialogueIsShowing: state.localEphemeral.newProjectDialogueIsShowing,
}};
export default connect(mapStateToProps, {siteboardAction})(App);

//import { useLocation } from 'react-router-dom';
//const location = useLocation();
//useEffect(() => {
//  setPath(location.pathname);
//}, [location]);
